import React from 'react';
import { Html5Entities } from 'html-entities';
import { Link } from 'react-router-dom';

const entities = new Html5Entities();

export const SectionList = (props) => {

    if(!props.data) return null;
    
    return(
        <div className="row" id="section-list">
            <div className="col-md-12">
                <ul className="list-unstyled">
                    { props.data.map((x,i) => {
                        let title = entities.decode(x.data.title);
                            return (<div className="col-md-12 section-list-item" key={i}>
                            <Link className="summary-title" to={`/ngc-summaries/details/${x.data.id}`} dangerouslySetInnerHTML={{__html: title}}/>
                            <ul className="list-unstyled">
                                <li><strong>Published By</strong> <a href="/" onClick={props.onClick.bind(null, 'authoringOrganizations', x.data.authoringOrganization)}>{x.data.authoringOrganization}</a></li>
                                <li><strong>Date</strong> {x.data.pubDateFormatted} </li>
                            </ul>
                        </div>)}
                    )}
                </ul>
            </div>
        </div>
    )
}